import { atom } from 'recoil'

export const pageState = atom({
  key: 'WorkflowsListPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    canCreateTrigger: false,
    fetchingResults: false,
    isEmptyState: false
  }
})
